// ⚠️ 必须是第一个 import：locales 初始化时读并去掉地址上的 ?lang=，要赶在 router 创建（读当前地址）之前
import { i18n, currentLocale } from './locales'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { VueQueryPlugin } from '@tanstack/vue-query'
import App from './App.vue'
import { router } from './router'
import { setLocaleGetter } from './api/http'
import { installHttpHooks } from './api/hooks'
import { queryClient } from './api/queryClient'
import './styles/main.css'

async function bootstrap() {
  // 本地假数据：仅开发态且显式开启时装载，不进生产构建路径
  if (import.meta.env.VITE_USE_MOCK === '1') {
    const { installMock } = await import('./mock')
    installMock()
  }

  setLocaleGetter(currentLocale)
  document.documentElement.lang = currentLocale()

  const app = createApp(App)
  app.use(createPinia())
  app.use(i18n)
  // 传 queryClient 实例而不是 queryClientConfig：会话清理要在 setup 之外调 queryClient.clear()，
  // 内建的那个只能靠 useQueryClient() 拿到。实例与配置都在 api/queryClient.ts
  app.use(VueQueryPlugin, { queryClient })
  app.use(router)

  // 必须在 pinia 与 router 都装好之后 —— hooks 里要用 store 和路由跳转
  installHttpHooks(router)

  app.mount('#app')
}

void bootstrap()
